import Mock from 'mockjs'

const userDB = [
  {
    username: 'admin',
    password: 'admin',
    id: 'admin-uuid',
    name: '管理员'
  },
  {
    username: 'editor',
    password: 'editor',
      id: 'editor-uuid',
    name: '编辑'
  },
  {
    username: 'user1',
    password: 'user1',
      id: 'user1-uuid',
    name: '用户1'
  }
]

Mock.mock('/api/login', 'post', ({ url, type, body }) => {
  const bodyObj = JSON.parse(body)
  const user = userDB.find(e => e.username === bodyObj.username && e.password === bodyObj.password)
  if (user) {
    return {
      code: 200,
      msg: '登录成功',
      data: {
        ...user,
          accessToken: 'd787syv8dys8cas80d9s0a0d8f79ads56f7s4d56f879a8as89fd980s7dg'
      }
    }
  } else {
    return {
      code: 401,
      msg: '用户名或密码错误',
      data: {}
    }
  }
})

Mock.mock('/api/user/info', 'post', ({ url, type, body }) => {
    console.log("=========2222222:");
    return {
        "code": 200,
            "msg": "",
            "data": {
            "userName": "MenuManager",
                "userRoles": [
                "R_MENUADMIN"
            ],
                "userPermissions": [
                "p_menu_view",
                "p_menu_edit",
                "p_menu_menu"
            ],
                "accessMenus": [
                {
                    "title": "系统",
                    "path": "/system",
                    "icon": "cogs",
                    "children": [
                        {
                            "title": "系统设置",
                            "icon": "cogs",
                            "children": [
                                {
                                    "title": "菜单管理",
                                    "path": "/system/menu",
                                    "icon": "th-list"
                                }
                            ]
                        },
                        {
                            "title": "组织架构",
                            "icon": "pie-chart",
                            "children": [
                                {
                                    "title": "部门管理",
                                    "path": "/system/role",
                                    "icon": "html5"
                                },
                                {
                                    "title": "职位管理",
                                    "icon": "opencart"
                                }
                            ]
                        }
                    ]
                }
            ],
                "accessRoutes": [
                {
                    "name": "System",
                    "path": "/system",
                    "component": "layoutHeaderAside",
                    "componentPath": "layout/header-aside/layout",
                    "meta": {
                        "title": "系统设置",
                        "cache": true
                    },
                    "children": [
                        {
                            "name": "MenuPage",
                            "path": "/system/menu",
                            "component": "menu",
                            "componentPath": "pages/sys/menu/index",
                            "meta": {
                                "title": "菜单管理",
                                "cache": true
                            }
                        },
                        {
                            "name": "RoutePage",
                            "path": "/system/route",
                            "component": "route",
                            "componentPath": "pages/sys/route/index",
                            "meta": {
                                "title": "路由管理",
                                "cache": true
                            }
                        },
                        {
                            "name": "RolePage",
                            "path": "/system/role",
                            "component": "role",
                            "componentPath": "pages/sys/role/index",
                            "meta": {
                                "title": "角色管理",
                                "cache": true
                            }
                        },
                        {
                            "name": "UserPage",
                            "path": "/system/user",
                            "component": "user",
                            "componentPath": "pages/sys/user/index",
                            "meta": {
                                "title": "用户管理",
                                "cache": true
                            }
                        },
                        {
                            "name": "InterfacePage",
                            "path": "/system/interface",
                            "component": "interface",
                            "meta": {
                                "title": "接口管理"
                            }
                        }
                    ]
                }
            ],
                "accessInterfaces": [
                {
                    "path": "/menu/:id",
                    "method": "get"
                },
                {
                    "path": "/menu",
                    "method": "get"
                },
                {
                    "path": "/menu/save",
                    "method": "post"
                },
                {
                    "path": "/interface/paged",
                    "method": "get"
                }
            ],
                "isAdmin": 0,
                "avatarUrl": "https://api.adorable.io/avatars/85/abott@adorable.png"
        }
    }


})
Mock.mock('/api/menu', 'post', ({ url, type, body }) => {
    return {
        "code": 200,
        "msg": "",
            "data": [
                {
                    "id": "2bf39892-f047-44b1-88d3-ccd7ea5c8c45",
                    "parentId": 0,
                    "title": "系统",
                    "path": "/system",
                    "icon": "cogs",
                    "sort": "1",
                    "type": 1,
                    children: [
                {
                    "id": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "parentId": "2bf39892-f047-44b1-88d3-ccd7ea5c8c45",
                    "title": "系统设置",
                    "icon": "cogs",
                    "sort": "1",
                    "type": 1,
                    children: [
                {
                    "id": "1f3ea5ba-0d67-4710-b75c-52a267296b85",
                    "parentId": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "title": "菜单管理",
                    "path": "/system/menu",
                    "icon": "th-list",
                    "sort": "1",
                    "type": 1,
                    "permission": "p_menu_menu"
                },
                {
                    "id": "34943e8f-5e57-4038-bd2f-6c13e3c5f168",
                    "parentId": "1f3ea5ba-0d67-4710-b75c-52a267296b85",
                    "title": "2-查询菜单",
                    "sort": "2",
                    "type": 2,
                    "permission": "p_menu_view"
                },
                {
                    "id": "3423218d-886c-4fb7-944d-42afe4c03076",
                    "parentId": "1f3ea5ba-0d67-4710-b75c-52a267296b85",
                    "title": "3-修改菜单",
                    "sort": "3",
                    "type": 2,
                    "permission": "p_menu_edit"
                },
                {
                    "id": "c2578794-328c-4f0f-bbba-289ebdace7f1",
                    "parentId": "1f3ea5ba-0d67-4710-b75c-52a267296b85",
                    "title": "1-菜单权限",
                    "type": 2,
                    "sort": "1",
                    "permission": "p_menu_menu"
                }]},
                {
                    "id": "6db38bfe-9ad0-4db4-a9be-28082741ef20",
                    "parentId": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "path": "/system/route",
                    "title": "路由管理",
                    "type": 1,
                    "permission": "p_route_menu",
                    "sort": "2",
                    "icon": "share-alt-square"
                },
                {
                    "id": "2b453777-ddb0-4806-8ab0-4ec56167cdb3",
                    "parentId": "6db38bfe-9ad0-4db4-a9be-28082741ef20",
                    "title": "1-菜单权限",
                    "type": 2,
                    "permission": "p_route_menu"
                },
                {
                    "id": "1a74ac59-001c-4914-874e-6dbefe33415c",
                    "parentId": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "title": "角色管理",
                    "path": "/system/role",
                    "type": 1,
                    "sort": "3",
                    "icon": "users",
                    "permission": "p_role_menu"
                },
                {
                    "id": "d0d47bda-ab26-4909-a7f2-74bc2591a357",
                    "parentId": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "title": "用户管理",
                    "path": "/system/user",
                    "sort": "4",
                    "type": 1,
                    "icon": "user",
                    "permission": "p_user_menu"
                },
                {
                    "id": "85bfdc38-fca4-4703-ad22-2cba711fc42a",
                    "parentId": "52500348-50f0-4327-a898-9e4b9893f1a9",
                    "title": "接口管理",
                    "path": "/system/interface",
                    "type": 1,
                    "sort": "5",
                    "icon": "paper-plane",
                    "permission": "p_interface_menu"
                },
                {
                    "id": "5e5b0453-cb24-4a8f-89ef-360922cecba5",
                    "parentId": "1a74ac59-001c-4914-874e-6dbefe33415c",
                    "title": "1-菜单权限",
                    "type": 2,
                    "permission": "p_role_menu"
                },
                {
                    "id": "97273b77-bda3-47ad-bd93-3c904fb8fb10",
                    "parentId": "d0d47bda-ab26-4909-a7f2-74bc2591a357",
                    "title": "1-菜单权限",
                    "type": 2,
                    "permission": "p_user_menu"
                },
                {
                    "id": "21352cb0-870b-40f0-acc9-362846fd1506",
                    "parentId": "85bfdc38-fca4-4703-ad22-2cba711fc42a",
                    "title": "1-菜单权限",
                    "type": 2,
                    "permission": "p_interface_menu"
                },
                {
                    "id": "18c7a1e3-3c69-4242-afd7-6f54bfdce271",
                    "parentId": "2bf39892-f047-44b1-88d3-ccd7ea5c8c45",
                    "title": "组织架构",
                    "sort": "2",
                    "type": 1,
                    "icon": "pie-chart"
                },
                {
                    "id": "dc5667cf-85a8-446e-8e69-354a684a762a",
                    "parentId": "18c7a1e3-3c69-4242-afd7-6f54bfdce271",
                    "title": "部门管理",
                    "type": 1,
                    "isLock": false,
                    "sort": "1",
                    "icon": "html5"
                },
                {
                    "id": "0fda8037-61df-4a1c-8f9b-18f287d51049",
                    "parentId": "18c7a1e3-3c69-4242-afd7-6f54bfdce271",
                    "title": "职位管理",
                    "sort": "2",
                    "type": 1,
                    "icon": "opencart"
                },
                {
                    "id": "6a0c4206-a78c-4459-bd36-3c8972b7bb53",
                    "parentId": "dc5667cf-85a8-446e-8e69-354a684a762a",
                    "title": "1-菜单权限",
                    "sort": "1",
                    "type": 2
                },
                {
                    "id": "ec47ad63-fb2e-4988-90ec-77fe4e398839",
                    "parentId": "0fda8037-61df-4a1c-8f9b-18f287d51049",
                    "title": "1-菜单权限",
                    "sort": "1",
                    "type": 2
                }]}
            ]
        }
})